module.exports = __webpack_public_path__ + "files/SPIADI2026 - Journée Nationale - Appel à communication.9f440ef60b6752b3ee8c92358ffb65f6.pdf";